/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 17/12/2024
 */

import {appHelper} from "../../../utils/helpers/appHelper.js";
import auth from "../../../middleware/auth.js";
import shortcuts from "../../../middleware/shortcuts.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";

export const HrAppEmployee = [
    {
        path: appHelper.path.hrApp + '/employee',
        name:'hrAppEmployee',
        component: routeHelper.asyncComponentWithLoader(() => import('../views/employee/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.hrApp + '/employee/blood',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth, shortcuts] },
        children: [
            {
                path: '',
                name: 'hrAppBlood',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/blood/index.vue'))
            }
        ]
    },
    {
        path: appHelper.path.hrApp + '/employee/religion',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth] },
        children: [
            {
                path: '',
                name: 'hrAppReligion',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/blood/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            }
        ]
    },
    {
        path: appHelper.path.hrApp + '/employee/marital',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth] },
        children: [
            {
                path: '',
                name: 'hrAppMarital',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/blood/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            }
        ]
    },
    {
        path: appHelper.path.hrApp + '/employee/education',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth] },
        children: [
            {
                path: '',
                name: 'hrAppEducation',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/blood/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            }
        ]
    },
    {
        path: appHelper.path.hrApp + '/employee/family',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth] },
        children: [
            {
                path: '',
                name: 'hrAppFamily',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/blood/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            }
        ]
    },
    {
        path: appHelper.path.hrApp + '/employee/status',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth] },
        children: [
            {
                path: '',
                name: 'hrAppStatus',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/status/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            }
        ]
    },
    {
        path: appHelper.path.hrApp + '/employee/grade',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth] },
        children: [
            {
                path: '',
                name: 'hrAppGrade',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/grade/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            }
        ]
    }
];
